import React, { useEffect, useState } from "react";
import { InputNumber, Button, Typography, message, Spin } from "antd";
import { DeleteOutlined, LoadingOutlined } from "@ant-design/icons";
import { useValidateCart } from "../../hooks/useCartItems";
import { useDebounce } from "../../hooks/useDebounce";



const { Text } = Typography;

const CartItem = ({ item, dispatch }) => {
  const [draftQty, setDraftQty] = useState(item.qty);

  const debouncedQty = useDebounce(draftQty, 600);

  const {
    mutateAsync: validateCartAsync,
    isLoading,
  } = useValidateCart();

  // sync external updates
  useEffect(() => {
    setDraftQty(item.qty);
  }, [item.qty]);

  // validation pipeline
  useEffect(() => {
    if (!debouncedQty || debouncedQty < 1) return;
    if (debouncedQty === item.qty) return;

    const pieceQty =
      debouncedQty * (item.conversionRate || 1);

    validateCartAsync([
      {
        productId: item.productId,
        qty: pieceQty,
      },
    ])
      .then((res) => {
        if (!res.isValid) {
          const invalid = res.invalidItems?.find(
            (x) => x.productId === item.productId
          );

          if (invalid) {
            const rate = item.conversionRate || 1;

            const requested = Math.ceil(
              invalid.requested / rate
            );

            const available = Math.floor(
              invalid.available / rate
            );

            message.warning(
              `${item.title}: Requested ${requested}, Available ${available}`
            );

            setDraftQty(item.qty);

            if (invalid.correctedQty !== undefined) {
              dispatch({
                type: "UPDATE_QUANTITY",
                payload: {
                  productId: item.productId,
                  qty: Math.floor(
                    invalid.correctedQty / rate
                  ),
                },
              });
            }
          }
        } else {
          dispatch({
            type: "UPDATE_QUANTITY",
            payload: {
              productId: item.productId,
              qty: debouncedQty,
            },
          });
        }
      })
      .catch(() => {
        message.error("Validation failed");
        setDraftQty(item.qty);
      });
  }, [
    debouncedQty,
    item.qty,
    item.productId,
    item.title,
    item.conversionRate,
    dispatch,
    validateCartAsync,
  ]);

  return (
    <div className="modern-cart-item">

      {/* LEFT */}
      <div className="modern-cart-item__left">

        <img src={item.image} alt={item.title} />

        <div>
          <h4>{item.title}</h4>

          <Text type="secondary">
            {item.displayUnitName}
          </Text>

          <div className="item-price">
            KES {item.displayPrice.toLocaleString()}
          </div>
        </div>
      </div>

      {/* RIGHT */}
      <div className="modern-cart-item__right">

        {/* QTY INPUT */}
        <div className="qty-control">

          <InputNumber
            min={1}
            value={draftQty}
            onChange={(val) =>
              setDraftQty(val || 1)
            }
            onPressEnter={(e) =>
              e.target.blur()
            }
            style={{ width: 80 }}
          />

        </div>

        {/* TOTAL */}
        <div className="item-total">
          KES{" "}
          {(
            item.displayPrice *
            draftQty
          ).toLocaleString()}
        </div>

        {/* DELETE */}
        <Button
          danger
          icon={<DeleteOutlined />}
          onClick={() =>
            dispatch({
              type: "REMOVE_FROM_CART",
              payload: item.productId,
            })
          }
        />

      </div>

      {/* VALIDATION STATE */}
      {isLoading && (
        <div className="cart-item-loading">
          <Spin
            indicator={<LoadingOutlined spin />}
            size="small"
          />
          <Text type="secondary">
            Validating stock...
          </Text>
        </div>
      )}

    </div>
  );
};

export default CartItem;